export interface Target {
  element: HTMLElement;
  id: string;
  label: string;
}
